<div class="schedule-form-item clearfix">
  <label class="modal-label" for="weekly">On</label>
  <div class="row">
    <button
      type="button"
      class="select-button"
      *ngFor="let opt of options"
      [value]="opt.value"
      [class.selected]="dayOfWeek === opt.name"
      [attr.data-test]="opt.name"
      (click)="handleDayOfWeekChange(opt.value)"
    >
      {{ opt.displayName }}
    </button>
  </div>
</div>
